import React from "react";

const Footer = (props) => {
  return <div className="footer dashboard"></div>;
};

export default Footer;
